import { twMerge } from '@/lib/classname/twMerge'
import type { PlacementAxis } from 'react-aria'
import { OverlayArrow } from 'react-aria-components'

const ARROW_GEOMETRY = {
  bottom: {
    className: 'h-1 w-2 -translate-y-[2px] hd:-translate-y-[2.5px]',
    viewBox: '0 0 20 10',
    outer: 'M-2.5 12.5 L8.5 1.5 Q10 0 11.5 1.5 L22.5 12.5',
    inner: 'M-1 13 L9 3 Q10 2 11 3 L21 13 L21 15 L-1 15 Z',
  },
  top: {
    className: 'h-1 w-2 translate-y-[2px] hd:translate-y-[2.5px]',
    viewBox: '0 0 20 10',
    outer: 'M-2.5 -2.5 L8.5 8.5 Q10 10 11.5 8.5 L22.5 -2.5',
    inner: 'M-1 -3 L9 7 Q10 8 11 7 L21 -3 L21 -5 L-1 -5 Z',
  },
  left: {
    className: 'h-2 w-1 translate-x-[2px] hd:translate-x-[2.5px]',
    viewBox: '0 0 10 20',
    outer: 'M-2.5 -2.5 L8.5 8.5 Q10 10 8.5 11.5 L-2.5 22.5',
    inner: 'M-3 -1 L7 9 Q8 10 7 11 L-3 21 L-5 21 L-5 -1 Z',
  },
  right: {
    className: 'h-2 w-1 -translate-x-[2px] hd:-translate-x-[2.5px]',
    viewBox: '0 0 10 20',
    outer: 'M12.5 -2.5 L1.5 8.5 Q0 10 1.5 11.5 L12.5 22.5',
    inner: 'M13 -1 L3 9 Q2 10 3 11 L13 21 L15 21 L15 -1 Z',
  },
}

function arrowGeometry(placement: PlacementAxis | null) {
  if (placement === 'top' || placement === 'left' || placement === 'right') {
    return ARROW_GEOMETRY[placement]
  }

  return ARROW_GEOMETRY.bottom
}

export function PopoverArrow({ dataTestId }: { dataTestId?: string }) {
  return (
    <OverlayArrow>
      {({ placement }) => {
        const geometry = arrowGeometry(placement)

        return (
          <svg
            viewBox={geometry.viewBox}
            className={twMerge('block overflow-visible', geometry.className)}
            aria-hidden
            data-testid={`${dataTestId ?? 'popover'}/arrow`}
          >
            <path d={geometry.outer} className="fill-brand-2-900" />
            <path d={geometry.inner} className="fill-white" />
          </svg>
        )
      }}
    </OverlayArrow>
  )
}
